import { render } from "./ItemTitle.vue?vue&type=template&id=b52c0c42&ts=true"
import script from "./ItemTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemTitle.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b52c0c42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b52c0c42', __exports__)) {
    api.reload('b52c0c42', __exports__)
  }
  
  module.hot.accept("./ItemTitle.vue?vue&type=template&id=b52c0c42&ts=true", () => {
    api.rerender('b52c0c42', render)
  })

}


export default __exports__